import {
  type PopupProps,
  Leaderboard as LeaderboardPopup
} from '@CS/components/Popups';

import API from '@/services/api';
import { connect } from 'react-redux';
import { useCurrentWeek } from '@/hooks';
import type { Username } from '@/redux/user/types';
import { getUserUsername, getUserTeamId } from '@/redux/user/selectors';

type LeaderboardProps = PopupProps & {
  username: Username;
  teamId?: string;
  game?: number;
};

const Leaderboard = ({
  teamId = '',
  username,
  game,
  ...props
}: LeaderboardProps) => {
  const campaignGame = API.getCampaignGame(game);
  const week = useCurrentWeek(campaignGame);

  const getWeekScores = async (week: number) => {
    const leaderboard = await API.getCampaignLeaderboard({
      rangeNumber: week + 1,
      gameIndex: game,
      limit: 10,
      teamId
    });

    const {
      position = -1,
      participant: { score = 0 }
    } = leaderboard.my ?? {
      participant: {}
    };

    return {
      userData: { name: username ?? '', position, score },

      weekScores: leaderboard.items.map(({ user, score }) => ({
        name: user.username,
        score: score
      }))
    };
  };

  return (
    <LeaderboardPopup
      getWeekScores={getWeekScores}
      currentWeek={week}
      {...props}
    />
  );
};

const mapStateToProps = (state: never) => ({
  username: getUserUsername(state),
  teamId: getUserTeamId(state)
});

export default connect(mapStateToProps)(Leaderboard);
